// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y){
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-core/~/core-js/modules/$.same-value.js
 ** module id = 109
 ** module chunks = 0
 **/